export const selectRoomDetails = state => state.roomPageDetailReducer.roomSelected

export const selectRoomDetailsId = state => state.roomPageDetailReducer.roomSelected.id

export const selectRoomDetailsUserId = state => state.roomPageDetailReducer.roomSelected.userId